
import axios from "axios";
import statusCheck from "/src/utils/statusCheck.js";
const tokenExpireTime = new Date(parseInt(localStorage.getItem('expire-on')));
const tokenRefresh = () => {

    let timeNow = new Date;
    let timeLeft = new Date(parseInt(localStorage.getItem('expire-on')));
    timeLeft.setSeconds(timeLeft.getSeconds() - process.env.VUE_APP_TOKEN_TIME_REMAINING);
    if (tokenExpireTime >= timeLeft) {
        axios.post(process.env.VUE_APP_CRAWLING_URL + "/auth/refresh")
            .then((response) => {
                    const token = "Bearer " + response.data["access_token"]
                    localStorage.setItem('users-token', token);
                    localStorage.setItem('expire-on', timeNow.toString());
                    axios.defaults.headers.common['Authorization'] = token;
                }
            )
            .catch(function (error) {
                    statusCheck(error.response.status);

                }
            )
    }
}
export default tokenRefresh;
